var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4360_5338)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4360_5338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 40.3346L21.5417 34.8346H21.0833C16.7444 34.8346 13.0625 33.3221 10.0375 30.2971C7.0125 27.2721 5.5 23.5902 5.5 19.2513C5.5 14.9124 7.0125 11.2305 10.0375 8.20547C13.0625 5.18047 16.7444 3.66797 21.0833 3.66797C23.2528 3.66797 25.2774 4.07252 27.1572 4.88164C29.0369 5.69075 30.6869 6.80602 32.1072 8.22747C33.5274 9.64891 34.6421 11.2989 35.4512 13.1775C36.2603 15.056 36.6654 17.0806 36.6667 19.2513C36.6667 21.543 36.2927 23.743 35.5447 25.8513C34.7967 27.9596 33.7724 29.9152 32.472 31.718C31.1716 33.5207 29.6285 35.1555 27.8428 36.6221C26.0572 38.0888 24.1096 39.3263 22 40.3346ZM21.0375 29.2888C21.5569 29.2888 22 29.1055 22.3667 28.7388C22.7333 28.3721 22.9167 27.9291 22.9167 27.4096C22.9167 26.8902 22.7333 26.4471 22.3667 26.0805C22 25.7138 21.5569 25.5305 21.0375 25.5305C20.5181 25.5305 20.075 25.7138 19.7083 26.0805C19.3417 26.4471 19.1583 26.8902 19.1583 27.4096C19.1583 27.9291 19.3417 28.3721 19.7083 28.7388C20.075 29.1055 20.5181 29.2888 21.0375 29.2888ZM19.7083 23.468H22.4583C22.4583 22.5513 22.55 21.9096 22.7333 21.543C22.9167 21.1763 23.4972 20.5041 24.475 19.5263C25.025 18.9763 25.4833 18.3805 25.85 17.7388C26.2167 17.0971 26.4 16.4096 26.4 15.6763C26.4 14.118 25.8732 12.9489 24.8197 12.1691C23.7661 11.3894 22.5207 11.0001 21.0833 11.0013C19.7389 11.0013 18.6083 11.3759 17.6917 12.1251C16.775 12.8744 16.1333 13.7831 15.7667 14.8513L18.3333 15.8596C18.4861 15.3402 18.7764 14.8287 19.2042 14.3251C19.6319 13.8216 20.2583 13.5692 21.0833 13.568C21.9083 13.5667 22.5274 13.7959 22.9405 14.2555C23.3536 14.715 23.5596 15.2192 23.5583 15.768C23.5583 16.2874 23.4056 16.7537 23.1 17.1668C22.7944 17.5799 22.4278 17.9997 22 18.4263C20.9306 19.343 20.2816 20.069 20.053 20.6043C19.8244 21.1396 19.7096 22.0942 19.7083 23.468Z",
    fill: "#00A86B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4360_5338",
    x: 3.5,
    y: 3.66797,
    width: 35.1641,
    height: 40.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4360_5338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4360_5338",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4360_5338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialView);
export default __webpack_public_path__ + "static/media/material-view.467f46d2cab314265db28267890cdcb0.svg";
export { ForwardRef as ReactComponent };